'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  display: block;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  padding-left: ', ';\n  padding-right: ', ';\n  margin: 0px;\n  background: none;\n  border: none;\n  outline: none;\n  font-family: ProximaNova;\n  font-size: inherit;\n  color: ', ';\n\n  ', ' &:focus {\n    outline: none;\n  }\n\n  &:disabled {\n    color: ', ';\n    pointer-events: none;\n  }\n\n  ', ';\n'], ['\n  width: 100%;\n  height: 100%;\n  display: block;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  padding-left: ', ';\n  padding-right: ', ';\n  margin: 0px;\n  background: none;\n  border: none;\n  outline: none;\n  font-family: ProximaNova;\n  font-size: inherit;\n  color: ', ';\n\n  ', ' &:focus {\n    outline: none;\n  }\n\n  &:disabled {\n    color: ', ';\n    pointer-events: none;\n  }\n\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n          color: transparent;\n          text-shadow: 0 0 0 gray;\n          text-align: center;\n        '], ['\n          color: transparent;\n          text-shadow: 0 0 0 gray;\n          text-align: center;\n        ']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Styles


var InputField = _styledComponents2.default.input(_templateObject, function (_ref) {
  var preIcon = _ref.preIcon;
  return (preIcon ? 34 : 10) + 'px';
}, function (_ref2) {
  var postIcon = _ref2.postIcon;
  return (postIcon ? 34 : 10) + 'px';
}, function (_ref3) {
  var red = _ref3.red;
  return red ? _colors.red : _colors.black;
}, function (_ref4) {
  var hideCursor = _ref4.hideCursor;
  return hideCursor ? (0, _styledComponents.css)(_templateObject2) : '';
}, function (_ref5) {
  var red = _ref5.red;
  return red ? _colors.red : _colors.darkGrey;
}, (0, _polished.placeholder)({
  color: _colors.darkGrey,
  'font-family': 'ProximaNova',
  'font-style': 'none'
}));

InputField.propTypes = {
  preIcon: _propTypes2.default.bool,
  postIcon: _propTypes2.default.bool,
  hideCursor: _propTypes2.default.bool,
  red: _propTypes2.default.bool
};
InputField.defaultProps = {
  preIcon: false,
  postIcon: false,
  hideCursor: false,
  red: false
};
exports.default = InputField;